import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assets-summary',
  templateUrl: './assets-summary.component.html',
  styleUrls: ['./assets-summary.component.scss']
})
export class AssetsSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
